import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';

const ChatUI = ({ messages, sendMessageHandler }) => {
  const [sortedMessages, setSortedMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [replyTo, setReplyTo] = useState(null);
  const messagesEndRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const messagesScrollRef = useRef({})

  useEffect(() => {
    // Sort messages by NotifiedOn date
    const sorted = [...messages].sort(
      (a, b) => new Date(a.NotifiedOn) - new Date(b.NotifiedOn)
    );
    setSortedMessages(sorted);
  }, [messages]);

  useEffect(() => {
    // Scroll to the bottom whenever messages change
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [sortedMessages]);

  useEffect(() => {
    if (messagesContainerRef.current) {
      const container = messagesContainerRef.current;
      if (container.scrollHeight <= container.clientHeight) {
        container.style.justifyContent = 'flex-end';
      } else {
        container.style.justifyContent = 'flex-start';
      }
    }
  }, [sortedMessages]);

  const handleSendMessage = async() => {
    if (inputMessage.trim() !== '') {
      const newMessage = {
        ID: Date.now(),
        NotifiedBy: 11, // Assuming the current user is ID 11
        NotificationText: inputMessage,
        NotifiedOn: new Date().toISOString(),
      };
      await sendMessageHandler(inputMessage, replyTo?.ID)
      setSortedMessages([...sortedMessages, newMessage]);
      setInputMessage('');
      setReplyTo(null);
      // API call to send the message can be placed here
      console.log('Message sent:', newMessage);
    }
  };

  // scroll to particular replied message
  const repliedMessageClickHandler = (message) => {
    const messageElement = messagesScrollRef.current[message.ParentID];
    console.log(messageElement,'messagedata1221')

    if (messageElement) {
      messageElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }


  return (
    <Container fluid className="p-4">
      <div
        ref={messagesContainerRef}
        style={{
        //   display: 'flex',
        //   flexDirection: 'column',
          height: '50vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          marginBottom: '1rem',
          scrollbarWidth: 'none', // For Firefox
          msOverflowStyle: 'none', // For IE and Edge
        }}
      >
        {sortedMessages.map((message) => (
          <Row
            key={message.ID}
            className={`justify-content-${message.NotifiedBy !== 11 ? 'start' : 'end'} mb-2`}
            ref={(el)=>{
                console.log(message.ID,'checkElement')
                if(el)
                {
                messagesScrollRef.current[message.ID] = el
                }
                else {
                    delete messagesScrollRef.current[message.ID];
                  }
            }}
          >
            <div
            className={`justify-content-${message.NotifiedBy !== 11 ? 'start' : 'end'} mb-2`}
            style={{maxWidth:"70%", textWrap:"wrap", wordBreak:"break-word", display: 'flex'}}
            >
            <Col xs={10} md={8} className={`text-${message.NotifiedBy !== 11 ? 'start' : 'end'}`}
               style={{width:"fit-content"}}
            >
              <div
                className={`p-2 rounded ${
                  message.NotifiedBy !== 11 ? 'bg-light text-dark' : 'bg-primary text-white'
                }`}
                style={{color:`${message.NotifiedBy !== 11? "#0f0e0": "#fff"}`}}
              >
                {(message.ParentID && message.NotifiedBy === 11) ? (
                  <div className="mb-2 p-2 bg-secondary text-white rounded" onClick={()=>repliedMessageClickHandler(message)}
                  style={{cursor:"pointer"}}
                  >
                    {sortedMessages.find((m) => m.ID === message.ParentID)?.NotificationText || 'Replied message not found'}
                  </div>
                ):""}
                {message.NotificationText}
              </div>
              {message.NotifiedBy !== 11 && (
                <Button
                  size="sm"
                  variant="link"
                  onClick={() => setReplyTo(message)}
                >
                  Reply
                </Button>
              )}
            </Col>
            </div>
          </Row>
        ))}
        <div ref={messagesEndRef} />
      </div>

      {replyTo && (
        <div className="mb-3 text-muted">
          Replying to: {replyTo.NotificationText}
          <Button
            size="sm"
            variant="link"
            onClick={() => setReplyTo(null)}
          >
            Cancel
          </Button>
        </div>
      )}

      <Form
        onSubmit={(e) => {
          e.preventDefault();
          handleSendMessage();
        }}
      >
        <Row>
          <Col>
            <Form.Control
              type="text"
              placeholder="Type your message..."
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter' && inputMessage.trim() !== '') {
                  handleSendMessage();
                  e.preventDefault();
                }
              }}
            />
          </Col>
          <Col xs="auto">
            <Button
              variant="primary"
              type="submit"
              disabled={inputMessage.trim() === ''}
            >
              Send
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default ChatUI;
